import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import Predictions from "@/pages/Predictions";
import { MainLayout } from "@/components/layout/MainLayout";
import { getPublicUpcomingPicks } from "@/lib/publicPicks.functions";
import { ServerPicksList, picksJsonLd } from "@/components/predictions/ServerPicksList";

const picksQuery = queryOptions({
  queryKey: ["public-upcoming-picks"],
  queryFn: () => getPublicUpcomingPicks(),
  staleTime: 5 * 60_000,
});

export const Route = createFileRoute("/predictions/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(picksQuery),
  head: ({ loaderData }) => ({
    meta: [
      { title: "Football Predictions Today — Every Pick Shows Its Work" },
      { name: "keywords", content: seoFor({ topics: ["footballPredictions", "predictions"] }).meta },
      { name: "description", content: "Every upcoming football prediction from Statlign's 50-strategy engine — ranked by conviction, with the reasoning laid bare. No black box, no hype." },
      { property: "og:title", content: "Football Predictions Today — Every Pick Shows Its Work" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Every upcoming football prediction from Statlign's 50-strategy engine — ranked by conviction, with the reasoning laid bare. No black box, no hype." },
      { name: "twitter:title", content: "Football Predictions Today — Every Pick Shows Its Work" },
      { name: "twitter:description", content: "Every upcoming football prediction from Statlign's 50-strategy engine — ranked by conviction, with the reasoning laid bare. No black box, no hype." },
    ],
    scripts: loaderData && loaderData.length ? [{ type: "application/ld+json", children: picksJsonLd(loaderData) }] : [],
  }),
  component: PredictionsRoute,
});

function PredictionsRoute() {
  const { data } = useSuspenseQuery(picksQuery);
  return (
    <MainLayout>
      <Predictions />
      <div className="container mx-auto px-4">
        <ServerPicksList picks={data} />
      </div>
    </MainLayout>
  );
}
